export var HEADER_HEIGHT = 56;
export var SECONDARY_NAV_WIDTH = 240;